import { useState } from 'react';
import { api, ApiError } from '../api';

/** Nieuw wachtwoord kiezen (na een reset door de beheerder, of vanuit de instellingen). */
export function ChangePassword({ forced, onDone, onCancel }: { forced?: boolean; onDone: () => void; onCancel?: () => void }) {
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [next2, setNext2] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const submit = async () => {
    setError(null);
    if (next !== next2) return setError('De twee wachtwoorden zijn niet gelijk.');
    setBusy(true);
    try {
      await api.changePassword(current, next);
      onDone();
    } catch (err) {
      setError(err instanceof ApiError && err.message !== err.code ? err.message : 'Wijzigen mislukt.');
    } finally {
      setBusy(false);
    }
  };
  const form = (
    <form className="form-grid ob-form" onSubmit={(e) => { e.preventDefault(); void submit(); }}>
      {!forced && <label>Huidig wachtwoord<input className="text-input" type="password" required autoComplete="current-password" value={current} onChange={(e) => setCurrent(e.target.value)} /></label>}
      <label>Nieuw wachtwoord<input className="text-input" type="password" required minLength={8} autoComplete="new-password" autoFocus={forced} value={next} onChange={(e) => setNext(e.target.value)} /></label>
      <label>Nieuw wachtwoord nog een keer<input className="text-input" type="password" required minLength={8} autoComplete="new-password" value={next2} onChange={(e) => setNext2(e.target.value)} /></label>
      {error && <p className="error" role="alert">{error}</p>}
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
        <button className="btn btn-primary" type="submit" disabled={busy}>{busy ? 'Bezig…' : 'Opslaan'}</button>
        {onCancel && <button className="btn btn-ghost" type="button" onClick={onCancel}>Annuleren</button>}
      </div>
    </form>
  );
  if (!forced) return form;
  return (
    <main className="center-screen ob-screen">
      <div className="ob-card">
        <div className="logo">tu<span>media</span></div>
        <h1 className="ob-title">Kies een nieuw wachtwoord</h1>
        <p className="lead muted">Je bent ingelogd met een tijdelijk wachtwoord van de beheerder. Kies nu je eigen wachtwoord (minstens 8 tekens).</p>
        {form}
      </div>
    </main>
  );
}
